import { SUM, PMT } from '__jsLibs/EXCEL';

const gettersFinancingExpense = {
	MonthlyPayment(state, getters) {
		if (
			getters.LoanAmount
			&& getters.LoanAmount !== 0
			&& getters.ofPayments
			&& getters.ofPayments !== 0
			&& state.result['interest_rate']
			&& state.result['interest_rate'] !== ''
		) {
			return +PMT(state.result['interest_rate'] / (12 * 100), getters.ofPayments, getters.LoanAmount) * -1;
		}
		return 0;
	},
	EscrowTaxes(state, getters) {
		if (
			state.result['annual_property_tax_override']
			&& +state.result['annual_property_tax_override'] > 0
		) {
			return state.result['annual_property_tax_override'] / 12;
		}
		else {
			if (
				getters.AnnualPropertyTaxEstimate
				&& +getters.AnnualPropertyTaxEstimate !== 0
			) {
				return getters.AnnualPropertyTaxEstimate / 12;
			}
		}
		return 0;
	},
	MonthlyPaymentWOPMI(state, getters) {
		return SUM([
			+getters.MonthlyPayment,
			+getters.EscrowTaxes,
			+state.result['escrow_homeowners_insurance'],
			+state.result['escrow_hazard_insurance']
		]);
	}
};

export {
	gettersFinancingExpense
};
